// consts
import { PAD_ALTERATION_TYPE } from 'app/config/pad';
// class
import PadVisit from 'app/redux/reducers/pad-creator/components-js/pad-visit/PadVisit';

const { CREATION } = PAD_ALTERATION_TYPE;

const TEMPLATE_NAME = 'PAD_CREATOR_VISIT';

const initialState = () => ({
  loading: false,
  errors: [],
  data: {
    loaded: [],
    screen: [],
    submit: []
  }
});

const reducer = (state = initialState(), action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      return {
        ...state,
        loading: true
      };
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = [...action.payload.errors];

      return {
        ...state,
        loading: false,
        errors
      };
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const newData = action.payload;
      const padVisits = newData;

      const padVisit = new PadVisit(state);

      // prettier-ignore
      return padVisit
        .prepare(padVisits, CREATION)
        .setLoading(false)
        .getState();
    }

    case `${TEMPLATE_NAME}_ADD`: {
      const newData = action.payload;
      const padVisit = newData.data;

      return new PadVisit(state).add(padVisit).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const newData = action.payload;
      const padVisit = { ...newData.data };

      return new PadVisit(state).edit(padVisit).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_CHANGE`: {
      const newData = action.payload;
      const padVisit = newData.data;

      return new PadVisit(state).change(padVisit).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const newData = action.payload;
      const padVisit = newData.data;

      return new PadVisit(state).remove(padVisit).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_SUSPEND`: {
      const newData = action.payload;
      const padVisit = newData.data;

      return new PadVisit(state).suspend(padVisit).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_UNSUSPEND`: {
      const newData = action.payload;
      const padVisit = newData.data;

      return new PadVisit(state).unsuspend(padVisit).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_APPLY_PREDEFINED_PAD_VISIT_MODEL`: {
      const newData = action.payload;
      const padVisit = newData.data;

      return new PadVisit(state)
        .applyPredefinedPadVisitModel(padVisit)
        .setLoading(false)
        .getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState();
    }

    default:
      return state;
  }
};

export default reducer;
